import { style } from 'typestyle'
import { important } from 'csx'
export const flexi = style({ display: important('flex') })
